import { render, staticRenderFns } from "./CourseApplicationItem.vue?vue&type=template&id=1d08b6dc"
import script from "./CourseApplicationItem.vue?vue&type=script&lang=js"
export * from "./CourseApplicationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports